import React, { useState, useRef, useEffect } from 'react'
import { Link, useNavigate, To } from 'react-router-dom'
import { List, X } from 'react-bootstrap-icons'

import { Header, Nav, VerticalRule } from '../../styles/navigation.style'
import { TIMELINE_COL_WIDTH_SECOND } from '../../styles/timeline/constants.style'
import { InitialsAvatarDropdown } from './navDropdowns/InitialsAvatarDropdown'
import { GenericNavigationBar } from './types'
import { BookLogo } from '../common/BookLogo'
import { BookLessonButton } from './BookLessonButton'
import { useLocation } from 'react-router-dom'



export const MobileNavigation: GenericNavigationBar = ({ reactRouterLinks }) => {
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)
  const navigate = useNavigate()

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (isOpen && menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isOpen])

  // 1. Update signature to accept the event and a looser type for onClick
  const handleLinkClick = (
    to: To, 
    event: React.MouseEvent<HTMLButtonElement>,
    onClick?: React.MouseEventHandler<any> | (() => void)
  ) => {
    setIsOpen(false)
    
    // Execute the optional onClick if it exists, passing the event
    if (onClick) {
      // Cast as any to avoid 'HTMLAnchorElement vs HTMLButtonElement' strictness
      (onClick as any)(event)
    }
    
    navigate(to)
  }

  return (
    <Header>
      <Nav>
        {/* <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}> */}
          
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <Link
            to="/search"
            aria-label="Go to search"
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: TIMELINE_COL_WIDTH_SECOND,
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: 'max-content',
                alignItems: 'center',
              }}
            >
              <span
                style={{
                  fontWeight: 'bold',
                  fontSize: '1.3rem',
                  lineHeight: '1',
                  color: 'var(--colors-slate12, #1e293b)',
                  letterSpacing: '-0.5px',
                }}
              >
                tute
              </span>

              <div style={{ width: '100%', height: '14px', marginTop: '0.1rem'}}>
                <BookLogo />
              </div>
            </div>
          </Link>
            <VerticalRule style={{ marginLeft: 0, marginRight: '0.5rem' }} />

            {/* <VerticalRule style={{ marginLeft: 0, marginRight: '0.5rem' }} /> */}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', position: 'relative' }}>
            <BookLessonButton />
            <VerticalRule />
            <InitialsAvatarDropdown reactLinks={reactRouterLinks} isMobile={true}/>

            
             
          </div>
        {/* </div> */}
      </Nav>
    </Header>
  )
}